import {
    PROVISION_SESSION_REQUEST,
    PROVISION_SESSION_SUCCESS,
    PROVISION_SESSION_FAIL,
    CLEAR_VIDEO_STATE,
    SET_USER_ROLE
} from '../actions/types';

const INITIAL_STATE = {
    token: null,
    roomName: null,
    loading: false,
    error: null,
    userRole: null,
};

const videoReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PROVISION_SESSION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                token: null,
                roomName: null,
            };
        case PROVISION_SESSION_SUCCESS:
            return {
                ...state,
                loading: false,
                token: action.payload.token,
                roomName: action.payload.roomName, 
                error: null,
            };
        case PROVISION_SESSION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                token: null,
                roomName: null,
            };
        case SET_USER_ROLE:
            return {
                ...state,
                userRole: action.payload,
            };
            case CLEAR_VIDEO_STATE:
                return {
                  ...state, // Keep existing state
                  loading: false,
                  error: null,
                  // Don't clear token and roomName during navigation
                };
        default:
            return state;
    }
};

export default videoReducer;